// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ActivityLogTable_wrapper__1saKS","filter":"ActivityLogTable_filter__2cFOg"};